var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    style: {
      verticalAlign: "middle"
    },
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    "aria-labelledby": "title"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 9.1v11.3H3.4V9.1h3.8zm.3-3.5c0 .6-.2 1-.6 1.4-.4.3-.9.5-1.6.5-.6 0-1.1-.2-1.5-.6-.4-.3-.6-.8-.6-1.3s.2-1 .6-1.4.9-.6 1.5-.6 1.1.2 1.5.6.6.8.7 1.4zm13.3 8.3v6.5H17v-6.1c0-.8-.2-1.4-.5-1.9s-.8-.7-1.5-.7c-.5 0-.9.1-1.2.4s-.6.6-.7 1c-.1.2-.1.5-.1.9v6.3H9.3v-7.4-4h3.8v1.6c.2-.2.3-.5.5-.6l.6-.6c.3-.2.6-.4 1-.5.4-.1.8-.2 1.3-.2 1.3 0 2.3.4 3.1 1.3.8 1 1.2 2.3 1.2 4z"
  })));
};
export { SvgLinkedin as ReactComponent };